
export async function collapseInit() {
    const collapseElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="collapse"]'));
    if (collapseElementList.length) {
        let {default: Collapse} = await import('bootstrap/js/dist/collapse')
        collapseElementList.map((collapseEl) => {
            new Collapse(collapseEl, {toggle: false});
        })
    }
}